module.exports = __webpack_public_path__ + "media/images/favicons/favicon-8a85875da4e7865e57550a16cef617e8.ico";